import { z } from 'zod'

export const generateLinkResponseSchema = z.object({
  url: z.string().url(),
})

export type GenerateLinkResponseDto = z.infer<typeof generateLinkResponseSchema>
